import { Registration } from '../../../components/RegistrationScene/Registration.js';

export const RegistrationPath = () => {
  return <Registration />;
};
